// De ene plek waar een woord op het scherm vandaan komt. (TAAL-001, 14-09-2026)
//
// Waarom dit bestaat: er staan schermen in de widget die volledig in het Engels zijn ingetypt --
// het keukenscherm (NEW, IN PREPARATION, READY) en de hotelwidget (FROM DATE, Select Date). Die
// woorden staan nergens in de vertaallijst van de winkel, dus een winkel kan er niets aan doen en
// een Nederlandse keuken leest Engels.
//
// Besluit Martijn 14-09-2026: via de vertaallijst van de winkel, met Nederlands als terugval.
//
// Zo werkt het. Elke tekst krijgt een sleutel. Staat die sleutel in de vertaallijst die de winkel
// heeft gevuld, dan wint die. Staat hij er niet -- en dat is zo tot iemand hem invult -- dan het
// Nederlandse woord dat hier in de code staat. Er is dus geen moment waarop er niets staat, en
// geen moment waarop er per ongeluk een sleutel op het scherm verschijnt.
//
// Waarom niet i18next, dat er al in zit: dat werkt met bestanden die wij meesturen, en dit moet
// per winkel anders kunnen zijn. De vertaallijst uit de database is die plek al.
//
// VERTALEN-WEBSITETALEN fase 2 (29-09-2026): de drie manieren (i18next-bestanden, de vertaallijst van de
// winkel en vaste teksten in de code) worden er één. Volgorde:
//   1. de vertaallijst van de winkel (languageWords), want die kan de winkelier zelf aanpassen;
//   2. de vaste vertaling in de taal van de widget (public/locales/<taal>/teksten.json, sleutel = de tekst zelf);
//   3. Engels, dan de tekst zelf (i18next-terugval).
// Zo staat er in een Duitse widget nooit meer een Nederlands woord omdat de winkel een sleutel niet heeft.

// De vertaler van i18next, gezet door src/i18n.js. Zonder (in een proef) blijft de tekst zelf staan.
let vertaler = null;

// De taal van de widget (i18n.language), gezet door src/i18n.js. Zonder: Nederlands. (widgetaudit bug 6)
let taalvrager = null;

/** Wordt aangeroepen door src/i18n.js zodra i18next klaar staat. */
export function zetVertaler(fn, taal) {
    vertaler = typeof fn === 'function' ? fn : null;
    if (typeof taal === 'function') taalvrager = taal;
}

/** De taal van de widget (nl, en, de, ...). Zonder i18next: nl. */
export function huidigeTaal() {
    const t = taalvrager ? taalvrager() : null;
    return t ? String(t).toLowerCase().split(/[-_]/)[0] : 'nl';
}

/**
 * Een vaste tekst uit de code in de taal van de widget. De tekst zelf is de sleutel; waarden op {0}, {1}.
 *
 *   vertaal('Even geduld')                     -> 'Bitte warten' (de)
 *   vertaal('Nog {0} plaatsen vrij', 3)       -> 'Noch 3 Plätze frei' (de)
 */
export function vertaal(standaard, ...waarden) {
    if (standaard == null) return '';
    const tekst = vertaler ? (vertaler(String(standaard)) || String(standaard)) : String(standaard);
    return waarden.length
        ? tekst.replace(/\{(\d+)\}/g, (heel, i) => (waarden[+i] == null ? heel : String(waarden[+i])))
        : tekst;
}

/**
 * Een tekst uit de vertaallijst van de winkel, anders de vaste vertaling van de standaardtekst.
 *
 * @param {object} vertaallijst  languageWords van de winkel (mag leeg zijn)
 * @param {string} sleutel       de sleutel in de vertaallijst
 * @param {string} standaard     de tekst die in de code stond (Nederlands of Engels)
 */
export function tekst(vertaallijst, sleutel, standaard) {
    const gevonden = vertaallijst && sleutel ? vertaallijst[sleutel] : undefined;
    if (typeof gevonden === 'string' && gevonden.trim() !== '') return gevonden;
    return vertaal(standaard);
}

/**
 * Het woord bij een sleutel, in de taal van de winkel.
 *
 * @param {object} vertaallijst  wat de winkel heeft gevuld (languageWords uit de winkel)
 * @param {string} sleutel       de sleutel waaronder het woord staat
 * @param {string} nederlands    wat er staat zolang de winkel niets heeft ingevuld
 */
export function woord(vertaallijst, sleutel, nederlands) {
    if (!sleutel) return vertaal(nederlands ?? '');

    const gevonden = vertaallijst ? vertaallijst[sleutel] : undefined;

    if (typeof gevonden !== 'string') return vertaal(nederlands ?? '');

    // Een lege of blanco vertaling is geen vertaling: dan de vaste vertaling in plaats van een leeg vak.
    return gevonden.trim() === '' ? vertaal(nederlands ?? '') : gevonden;
}

/**
 * De woorden van het keukenscherm. Eén plek, want ze staan op alle drie de keukenschermen.
 *
 * De sleutels zijn nieuw: tot iemand ze in de vertaallijst van een winkel zet, staat er Nederlands.
 */
export const KEUKEN = {
    nieuw: ['KeukenNieuw', 'Nieuw'],
    inBereiding: ['KeukenInBereiding', 'In de maak'],
    klaar: ['KeukenKlaar', 'Klaar'],
    eetzaal: ['KeukenEetzaal', 'In de zaak'],
    scherm: ['KeukenScherm', 'Keukenscherm'],
};

/** Hetzelfde voor de hotelwidget. */
export const HOTEL = {
    vanaf: ['HotelVanafDatum', 'Vanaf'],
    tot: ['HotelTotDatum', 'Tot'],
    kiesDatum: ['HotelKiesDatum', 'Kies een datum'],
};

/** Een woord uit zo'n groepje, met de vertaallijst erbij. */
export function uit(groep, naam, vertaallijst) {
    const regel = groep ? groep[naam] : null;

    if (!regel) return '';

    return woord(vertaallijst, regel[0], regel[1]);
}
